import { render, staticRenderFns } from "./SurveyThanks.vue?vue&type=template&id=33fb983d"
import script from "./SurveyThanks.vue?vue&type=script&lang=js"
export * from "./SurveyThanks.vue?vue&type=script&lang=js"
import style0 from "./SurveyThanks.vue?vue&type=style&index=0&id=33fb983d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports